import React from 'react'
import { Link } from 'react-router-dom'
import { routePathCabinet } from '../logined/Cabinet'
import { Button, Result } from 'antd'

export const DonateBuySuccess = (): React.ReactElement => (
	<Result
		status="success"
		title="Донат успешно приобретён!"
		subTitle="Теперь вы можете зайти на сервер."
		extra={[
			<Link key="to-personal" to={routePathCabinet} style={{ textDecoration: 'none' }}>
				<Button type="primary">
					В личный кабинет
				</Button>
			</Link>
		]}
	/>
)

export const routePathDonateBuySuccess = '/cabinet/donate/success'
